import React from 'react';
import { Navigate } from 'react-router-dom';
import { useReportAuth } from '../context/ReportAuthContext';

/**
 * ProtectedRoute
 *
 * Wraps any route that requires a valid report JWT.
 * If the user has no token they are redirected to the home page.
 *
 * The token is issued by the backend only after a successful Stripe payment,
 * so only paying customers can reach the wrapped page.
 */
export default function ProtectedRoute({ children }) {
  console.log('export default function ProtectedRoute({ children })');
  const { hasValidToken } = useReportAuth();

  if (!hasValidToken) {
    return <Navigate to="/" replace state={{ reason: 'auth_required' }} />;
  }

  return children;
}
